import React from 'react';
import PropTypes from 'prop-types';
import locales from '../locales';
import { getProductsURL, linkActionNewTarget } from '../utils/commons';
import CollapseButton from './CollapseButton';

const AccountResume = ({ lang, isCollapsed, collapseSidebar }) => {
  const t = locales(lang);

  return (
    <div className="account__resume">
      <div className="account__resume__content">
        <a
          className="account__resume__link upgrade__button"
          href="#"
          target="_blank"
          data-url={getProductsURL()}
          data-bypass={true}
          onClick={linkActionNewTarget}
          title={t('globalSidebar.actions.upgradePlan')}
        >
          {t('globalSidebar.actions.upgradePlan')}
        </a>
        <CollapseButton onClick={collapseSidebar} isCollapsed={isCollapsed} />
      </div>
    </div>
  );
};

AccountResume.propTypes = {
  lang: PropTypes.string,
  isCollapsed: PropTypes.bool,
  collapseSidebar: PropTypes.func,
};

export default AccountResume;
